/* @ngInject */
const myWagonIdSearch = (
  $$wagon,
  $$autocomplete,
  utils,
  wagonUtils,
  toaster,
  labels
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
      myWagons: '=',
      restrictSearch: '=',
      enableSearchButton: '=?',
      enableAddButton: '=?',
      enableRemoveButton: '=?',
      enableResetButton: '=?',
    },
    template: require('./myWagonIdSearch.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsOptions = $$wagon.metadata.fields

      $scope.searchWagon = async (_id) => {
        if (!wagonUtils.isIdValid(_id)) {
          return toaster.error($$wagon.labels.log.search.invalid)
        }
        let searchdata = {
          id: _id,
        }
        searchdata = utils.mergeObject(searchdata, $scope.restrictSearch)

        try {
          const response = await $$wagon.request.getBySearch(searchdata)
          const wagons = response.wagons
          toaster.message(response.message, response.color)
          if (wagons.length === 1) {
            $scope.myWagons.splice(0, $scope.myWagons.length)
            $scope.myWagons.push(wagons[0])
            $scope.myWagon.id = undefined
          }
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.addWagon = async (_id) => {
        if (!wagonUtils.isIdValid(_id)) {
          return toaster.error($$wagon.labels.log.search.invalid)
        }
        if (utils.isIdInArray($scope.myWagons, _id)) {
          return toaster.error(labels.wagon.log.save.alreadyInList)
        }
        let searchdata = {
          id: _id,
        }
        searchdata = utils.mergeObject(searchdata, $scope.restrictSearch)

        try {
          const response = await $$wagon.request.getBySearch(searchdata)
          const wagons = response.wagons
          if (wagons.length === 1) {
            $scope.myWagons.push(wagons[0])
            $scope.myWagon.id = undefined
            toaster.message(labels.wagon.log.save.addList)
          } else {
            toaster.message(labels.wagon.log.search.noResult, 'orange')
          }
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.removeWagon = (_id) => {
        if (!wagonUtils.isIdValid(_id)) {
          return toaster.error($$wagon.labels.log.search.invalid)
        }
        if (!utils.isIdInArray($scope.myWagons, _id)) {
          return toaster.error(labels.wagon.log.search.notInList)
        }
        utils.removeFromArray($scope.myWagons, _id)
        toaster.message(labels.wagon.log.search.removeFromList)
        $scope.myWagon.id = undefined
      }

      $scope.reset = () => {
        $scope.myWagon.id = undefined
        $scope.myWagons.splice(0, $scope.myWagons.length)
      }
    },
    link: {
      pre: (scope, element, attrs) => { },
      post: async (scope, element, attrs, ctrl) => {
        try {
          const ids = await $$autocomplete.request.get('id', 'wagons', scope.restrictSearch)
          const newIds = await $$autocomplete.request.get('idNew', 'wagons', scope.restrictSearch)
          scope.wagonIds = [...ids, ...newIds]
        } catch (error) {
          toaster.error(error)
        }
      },
    },
  }
}
export default myWagonIdSearch



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/search/myWagonIdSearch.js